import { useEffect, useState } from 'react';
import { getContestPrizes } from '../../../auth/_requests';
import type { ContestPrizeItem } from '../../../helpers/utils/types';

export const useContestPrizes = (token?: string) => {
  const [loading, setLoading] = useState(false);
  const [prizes, setPrizes] = useState<ContestPrizeItem[]>([]);

  useEffect(() => {
    const load = async () => {
      if (!token) return;
      setLoading(true);
      try {
        const res = await getContestPrizes(token);
        const sorted = [...(res?.data ?? [])].sort((a, b) => a.awardRank - b.awardRank);
        setPrizes(sorted);
      } catch (error) {
        console.error('Error fetching contest rent drops:', error);
        setPrizes([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  return { prizes, loading };
};
